function getStickyButton() {
  const button = document.querySelector('.site-sticky-button');
  return button;
}

function getFooter() {
  const footer = document.querySelector('.lhi-footer');
  return footer;
}

function setupStickyButtonFade() {
  const button = getStickyButton();

  if (!button) return;

  const footer = getFooter();

  let isHidden = false;

  function checkButtonVisibility() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Calculate if we're near the bottom (within 100px of bottom)
    const isNearBottom = scrollTop + windowHeight >= documentHeight - 100;

    let shouldHide = isNearBottom;

    // Check if footer is overlapping button
    if (footer && !shouldHide) {
      const footerRect = footer.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();

      // Check if footer is visible and overlapping button area
      const isFooterVisible = footerRect.top < windowHeight;
      const isOverlapping = footerRect.top < buttonRect.bottom + 20; // 20px buffer

      shouldHide = isFooterVisible && isOverlapping;
    }

    if (shouldHide && !isHidden) {
      button.style.transition = 'opacity 0.3s ease';
      button.style.opacity = '0';
      button.style.pointerEvents = 'none';
      isHidden = true;
    } else if (!shouldHide && isHidden) {
      button.style.transition = 'opacity 0.3s ease';
      button.style.opacity = '1';
      button.style.pointerEvents = 'auto';
      isHidden = false;
    }
  }

  // Throttle scroll events for better performance
  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        checkButtonVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Initial check
  checkButtonVisibility();

  // Listen for scroll events
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', checkButtonVisibility);
}

document.addEventListener('DOMContentLoaded', () => {
  setupStickyButtonFade();
});
